<template>
  <div class="footer-page">
    <img src="../assets/image/mobile/mhome/footer1.png" alt="" />
    <!-- 联系我们 -->
    <section class="contact" id="contact">
      <!-- <img src="../assets/image/mobile/mhome/contact.png" alt="" /> -->
      <div class="contact-us">
        <div class="title">
          <h4>CONTACT US</h4>
          <h4>联系我们</h4>
        </div>
        <div class="contact-info">
          <ul>
            <li>
              <div class="label">姓名</div>
              <input type="text" v-model="user.name" />
            </li>
            <li>
              <div class="label">电话</div>
              <input type="text" v-model="user.mobile" />
            </li>
            <li>
              <div class="label">邮箱</div>
              <input type="text" v-model="user.email" />
            </li>
          </ul>
          <div class="sumbit-btn" @click="submit">确定</div>
        </div>
      </div>
    </section>
    <!-- copyright -->
    <section class="copyright-box">
      <div class="top">
        <div class="left">
          <ul>
            <li v-for="(item, index) in navList" :key="index">
              <router-link :to="item.link" class="link">
                {{ item.desc }}</router-link
              >
            </li>
            <li class="link">
              <a href="#contact">联系我们</a>
            </li>
          </ul>
        </div>
        <div class="right">
          <img src="../assets/image/mobile/mhome/qrcode.png" alt="" />
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottom">
        <p>客户服务热线 : 400-688-1114</p>
        <p>地址：广东省广州市越秀区越华路116号迎商酒店11-12楼</p>
        <p>Copyright ©1998-2018 neohotels.cn</p>
        <p>
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >粤ICP备19016096号-1</a
          >
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        name: "",
        mobile: "",
        email: "",
      },
      showMobile: false,
      mywidth: "",
      navList: [
        {
          id: "tab1",
          desc: "首页",
          link: "/homePage",
        },
        {
          id: "tab2",
          desc: "品牌介绍",
          link: "/brand",
        },

        {
          id: "tab3",
          desc: "招商加盟",
          link: "/joinUs",
        },
        {
          id: "tab4",
          desc: "媒体中心",
          link: "/news",
        },
        {
          id: "tab5",
          desc: "环境展示",
          link: "/hotelScene",
        },
      ],
    };
  },
  created() {
    this.mywidth = innerWidth;

    if (this.mywidth < 768) {
      this.showMobile = true;
    }
  },
  methods: {
    contanthandel() {
      const regMobile = /^1[3-9]\d{9}$/;
      const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      const testMobile = regMobile.test(this.user.mobile);
      const testEmeil = regMobile.test(this.user.email);

      // if (!testMobile) {
      //   this.$message({
      //     message: `请输入格式正确的手机号`,
      //     offset: 100,
      //     type: "error",
      //   });
      //   return;
      // }
      // if (!testEmeil) {
      //   this.$message({
      //     message: `请输入格式正确的邮箱`,
      //     offset: 100,
      //     type: "error",
      //   });
      //   return;
      // }
      this.$http.post("/api/contact", this.user).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: `联系方式填写成功！`,
            offset: 100,
            type: "success",
          });
          this.user = {
            name: "",
            mobile: "",
            email: "",
          };
        } else {
          this.$message({
            message: `${res.data.msg}`,
            offset: 100,
            type: "error",
          });
        }
      });
    },
    submit() {
      this.showMobile && this.contanthandel();
    },
  },
};
</script>

<style lang="less" scoped>
.footer-page {
  min-height: 100vh;

  .contact {
    width: 100%;
    height: (632 / 3.75vw);
    background-image: url(../assets/image/mobile/mhome/contact.png);
    background-size: 100% 100%;
    padding: (263 / 3.75vw) (43 / 3.75vw) (43 / 3.75vw) (40 / 3.75vw);
    .contact-us {
      width: 100%;

      background-color: #fff;
      font-size: 4.26vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: (15 / 3.75vw);
      .title {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }
      h4 {
        font-size: 4.26vw;
        line-height: 1.5;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #000000;
      }

      .contact-info {
        width: 100%;

        margin-top: 3.5%;
        li {
          margin-bottom: (5 / 3.75vw);

          .label {
            font-size: 3.2vw;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1a1a1a;
            line-height: 1.5;
            margin-bottom: (7 / 3.75vw);
          }

          input {
            width: 100%;

            height: (30/ 3.75vw);
            outline: none;
            padding-left: (15/ 3.75vw);
            border: 1px solid #e0ca76;
          }
        }
        .sumbit-btn {
          display: flex;
          justify-content: center;
          align-items: center;

          width: 100%;
          margin-top: 20px;
          height: (30/ 3.75vw);
          font-size: 3.2vw;
          background-color: #e0ca76;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: #1a1a1a;
        }
      }
    }
  }
  .copyright-box {
    height: (375 / 3.75vw);
    padding: (45/ 3.75vw) (30/ 3.75vw);
    background-color: #000;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: (33/ 3.75vw);
      .left {
        li {
          .link,
          a {
            font-size: (12/ 3.75vw);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
      .right {
        width: (136/ 3.75vw);
      }
    }
    .bottom {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      p {
        font-size: 3.2vw;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.5;
      }
      a {
        color: #ffffff;
      }
    }
  }
}
</style>